import classNames from 'classnames'
import React, { useContext, useEffect, useState } from 'react'
import drapeauTunisie from '../../assets/drapeauxCarres/drapeauTunisie.svg'
import drapeauMaroc from '../../assets/drapeauMaroc.svg'

import ImagePaiementSonede from '../../assets/logoPaiementSonede.svg'
import ImagePaiementSteg from '../../assets/logoPaiementSteg.svg'
import ImagePaiementTopnet from '../../assets/logoPaiementTopnet.svg'
import ImagePaiementTT from '../../assets/logoPaiementTT.svg'
import ImagePaiementOoredoo from '../../assets/logoPaiementOoredoo.svg'
import ImagePaiementBEE from '../../assets/logoPaiementBEE.svg'
import ImagePaiementNety from '../../assets/logoPaiementNety.svg'

import topnetLogo from '../../assets/topnetLogo.svg'
import sonedeLogo from '../../assets/sonedeLogo.svg'
import stegLogo from '../../assets/stegLogo.svg'
import NetyLogo from '../../assets/netyLogo.svg'
import BeeLogo from '../../assets/beeLogo.svg'
import OoredooLogo from '../../assets/logoOoredoo2.svg'
import {logoModalTT} from '../../assets/index'

import paimentFactureContext from 'contexts/paimentFactureContext'
import StegInfoIcon from '../../assets/steginfo.svg'
import SonedInfoIcon from '../../assets/sonedinfo.svg'
import Modal from 'components/Modal'
import InputSelectComponent from 'components/inputSelectComponent'

interface Props {
  onChangeStep: any
  listeActiveProviders:any
  setSelectedModePaiement:(val:string)=>void
  setChoixpaiement:(val:string)=>void
  selectedModePaiement:string

  onChange: (value: string) => void
 
  setVAlueInput: (value: string) => void
  valueInput :string
  allowedLength: number[], 
  setAllowedLength: (val:number[])=>void
   setPlaceHolder: (value: string) => void
  placeHolder :string

  isOperateur: string
  paiementFactureUser: any
  billerCode: any
  facture: any
  setBillerCode: (value: string) => void
  objectReference: any
  setObjectReference: (value: string) => void
  functionTracks: any
}

const Choix: React.FC<Props> = ({
  onChangeStep,
  listeActiveProviders,
  setSelectedModePaiement,
  setChoixpaiement,
  selectedModePaiement,
  onChange,
  isOperateur,

  setVAlueInput,
  valueInput,
  placeHolder, 
  setPlaceHolder,
allowedLength,
 setAllowedLength,
  paiementFactureUser,
  billerCode,
  setBillerCode,

  functionTracks,

}) => {
const ListeOperateur=[

  {id:5 ,BillerCode:'STEG',  opSelect:'Steg', image : ImagePaiementSteg, logo:stegLogo, placeHolderOP:'Numéro de facture',lenghtregex:[9]},
  {id:6 ,BillerCode:'SONEDE', opSelect:'Soned', image : ImagePaiementSonede,logo:sonedeLogo, placeHolderOP:'Numéro de contrat', lenghtregex:[7,8]},
  {id:0 ,BillerCode:'TOPNET', opSelect:'Topnet', image :ImagePaiementTopnet,logo:topnetLogo, placeHolderOP:'Numéro de contrat', lenghtregex:[8]},
  {id:1 ,BillerCode:'TT', opSelect:'TT', image :ImagePaiementTT,logo:logoModalTT, placeHolderOP:'Numéro de contrat', lenghtregex:[8] },
  {id:2 ,BillerCode:'OOREDOO', opSelect:'OOREDOO', image :ImagePaiementOoredoo,logo:OoredooLogo, placeHolderOP:'Numéro de contrat', lenghtregex:[8]},
  {id:3 ,BillerCode:'BEE', opSelect:'BEE', image :ImagePaiementBEE,logo:BeeLogo, placeHolderOP:'Numéro de contrat', lenghtregex:[8]},
  {id:4 ,BillerCode:'NETY', opSelect:'NETY', image : ImagePaiementNety,logo:NetyLogo, placeHolderOP:'Numéro de contrat', lenghtregex:[8]},
]

const ListeOperapeurFiltree= ListeOperateur.filter(op=>listeActiveProviders.includes(op.BillerCode))

  const [isOpenLien,setIsOpenLien]= useState(false)
  const { paimentFacture, setPaimentFacture } = useContext(paimentFactureContext)

  const [selectedValue, setSelectedValue] = useState<string>('Tunisie')
  const [isClicked, setIsClicked] = useState(false)
  // const [allowedLength, setAllowedLength]=useState<number[]>([])

  const [isValidFacture, setIsValidFacture] = useState(false)
  const [openModalGuide, setOpenModalGuide] = useState(false)
  const handleSelectChange = (selectedValue: string) => {
    setSelectedValue(selectedValue)
  }
   const handleChangeModePaiement = (selectedValue: any) => {
    // const mode = lsiteModePaiement.find(item=> item.value=== selectedValue)?.label
    // if(mode)
    

    {setChoixpaiement(selectedValue.label)}
    setSelectedModePaiement(selectedValue.value)
  }
  const handleClick = () => {
    
    setIsClicked(!isClicked)
  }

  const handleInputChangeFacture = (e: any) => {
    const inputValueWithoutSpaces = e.target.value.replace(/\D/g, '').slice(0, 9)
    // setSonedNumero(inputValueWithoutSpaces)
    setVAlueInput(inputValueWithoutSpaces)
   
    const isValidFacture = allowedLength.includes(inputValueWithoutSpaces.length)
    setIsValidFacture(isValidFacture)

   
    if (isValidFacture)
    {  
      setPaimentFacture({ ...paimentFacture, objectReference: inputValueWithoutSpaces })
    } else{
      setPaimentFacture({ ...paimentFacture, objectReference: '' })
    }
      }


  useEffect(() => {
    if (paimentFacture) {
      onChange(paimentFacture?.isChoisiroperator || '')
    }
  }, [])

  const options: { icon: any; value: string; label: string }[] = [
    { icon: drapeauTunisie, value: 'Tunisie', label: 'Tunisie' },
    { icon: drapeauMaroc, value: 'Maroc', label: 'Maroc' },

  ]

 
  const lsiteModePaiement2:{ icon: any; value: string; label: string }[]=[
    {icon:'',value:'Carte Bancaire', label:'cb'},
    {icon:'',value:'Virement instantané', label:'volume'},
  ]

  const lsiteModePaiement:{ icon: any; value: string; label: string }[]=[
    {icon:'',label:'Carte Bancaire', value:'cb'},
    {icon:'',label:'Virement instantané', value:'volume'},
  ]
  
  return (
    <div>
      <div className='flex flex-col gap-4 w-full '>
        {/* <div className="h3">
          Pays de destination
        </div>
     
            <CustomSelect
              options={options}
              value={options.find((item) => item.label === selectedValue)?.label || 'Pays'}
              onChange={handleSelectChange}
              placeholder=""
              icon={options.find((item) => item.value === selectedValue)?.icon}
              disableMaroc= {true}
              marginRightIcon='mr-5'
              marginRight='pl-3 hover:cursor-default bg-transparent border border-[#AEB6FB]  hover:border-[#AEB6FB]'
              height="h-[50px]"
              // background="bg-gray-100 rounded-full "
              textSize="text-[15px] sm:text-[12px] text-[#35258B] font-roboto text-[18px]"
              heightDropdown=""
              roundedIcon="rounded-[0px]"
            /> */}
          

      {/* <div className="flex flex-col mt-5 gap-2">
        <div className="h3">
          Mode de paiement <span className="text-[#FF0000]">*</span>
        </div>
         <CustomSelect
              options={lsiteModePaiement}
              value={lsiteModePaiement.find((item) => item.label === selectedModePaiement)?.label || 'Carte Bancaire'}
              onChange={handleChangeModePaiement}
              placeholder=""
              height='relative h-[50px]'
              icon={lsiteModePaiement.find((item) => item.value === selectedModePaiement)?.icon}
              disableMaroc= {false}
              showArrow={true}
              heightListe='pl-4'
              marginRight='pl-2 hover:cursor-default bg-transparent border border-[#AEB6FB]  hover:border-[#AEB6FB]'
             heightDropdown="max-h-max w-full z-50 "
              marginRightIcon=" mr-4"
              textSize="text-[15px] sm:text-[12px]  font-roboto text-[18px]"
              roundedIcon="rounded-[0px]"
            />      
     
      </div> */}

      <InputSelectComponent
          liste={lsiteModePaiement2}
          // isOpen={isOpenLien}
          // setIsOpen={setIsOpenLien}
          value={selectedValue}
          setValue={setSelectedValue}
          label='Pays de destination'
          icon={options.find((item) => item.value === selectedValue)?.icon}
          handleClick={handleChangeModePaiement}
          isDropDown={false}
        />


      <InputSelectComponent
          liste={lsiteModePaiement2}
          isOpen={isOpenLien}
          setIsOpen={setIsOpenLien}
          value={selectedModePaiement}
          setValue={setSelectedModePaiement}
          label='Mode de paiement'
          handleClick={handleChangeModePaiement}
        />

        
        <div className="h3  ">
          Sélectionnez l’opérateur <span className="text-[#FF0000]">*</span>{' '}
        </div>
        <div
          className={`flex  gap-4 xl:gap-2 flex-wrap col items-center lg:flex-row justify-center
            ${selectedValue === 'Tunisie' ? 'block' : 'hidden' }`}
        >  

        {ListeOperapeurFiltree.map(( item, index)=>(
          <div  key={index}
           className={`
              rounded-[13px] hover:cursor-pointer hover:scale-105 h-[90px] xl:h-[70px] 
              ${(item.BillerCode==='STEG' || item.BillerCode==='SONEDE' ) ? 'w-[46%]' : 'w-[30%]'}
              ${item.BillerCode === billerCode && 'border-2 border-[#5754E5] shadow-[0_0_4px_rgba(87,84,229,0.5)]' }
            `}
             onClick={()=>{
                onChange(item.opSelect)
               setAllowedLength(item.lenghtregex)
                setPlaceHolder(item.placeHolderOP)
                setBillerCode(item.BillerCode)
                setVAlueInput('')
                setPaimentFacture({ ...paimentFacture, isChoisiroperator: item.BillerCode, logoOperateur: item.logo })
                handleClick()
               if(item.BillerCode=== 'STEG' || item.BillerCode === 'SONEDE'){ setOpenModalGuide(true)}
                } }
          >
            <div 
            className={`
              ${item.BillerCode === billerCode ? 'bg-[#E2E2FB] border-4 border-[#FFF]' : 'bg-[#EEEEEE]'}
              ${(billerCode && item.BillerCode !== billerCode) && ' opacity-55' }
              flex items-center justify-center rounded-[13px]  w-full h-full  
              `} 
            >
             
              <img className={`  xl:w-[60px]  ${item.BillerCode ==='TOPNET' || item.BillerCode==='OOREDOO' ? 'w-[120px] h-auto' : 'w-[75px] h-auto'} `}src={item.image} alt={` paiemnet de facture ${item.BillerCode}`}/>

            </div>
          </div>
        ))}
          
        </div>
        {
          billerCode &&
          <div>
            <div className='h3 mt-6 flex'>
              {placeHolder}
              {/* {(billerCode === 'SONEDE' || billerCode ===  'STEG') 
            ?  'Numéro de contrat' : 'Numéro ADSL'}  */}
            <span className={`text-red-500 ml-1 `} >*</span>
              {/* {(isOperateur === 'Steg' || isOperateur === 'Soned') && (
              
                <img className='ml-2'
                onClick={() => {
                  setOpenModalGuide(true)
                }}
                src={InfoLogo} />
              // </div>
            )} */}
            </div>

            <div className="flex flex-col gap-2 h-[50px] font-roboto ">
              <div className=' flex items-center gap-4 border-[#AEB6FB] border w-full text-[15px] focus:border-[#5754E5]  sm:text-[12px] sm:h-[45px] h-[56px]  text-[#1D3A70] rounded-xl p-5'>
              
                <input
                className="outline-none placeholder-[#D1D1FF] w-full"
                type="text"
                value={valueInput}
                placeholder={ valueInput || placeHolder}
                name="sonedNumero"
                autoComplete='off'
                onChange={handleInputChangeFacture}
              />

              </div>
              { valueInput.length > 0 && !allowedLength.includes(valueInput.length) && (
                <p className="text-red-500 text-[12px]">Ce champ doit comporter  {allowedLength.length===1 ?  allowedLength[0] : `${allowedLength[0]} ou ${allowedLength[1]}`} chiffres</p>
              )}
            </div>
          </div>  
        }

          <button
            disabled={!allowedLength.includes(valueInput.length)}
            className={classNames(
              `text-[18px] mt-10 text-[#FFF] w-full h-[56px] sm:mt-[15px] items-center rounded-xl `,
              !(allowedLength.includes(valueInput.length))
                ? 'bg-[#D1D1FF]'
                : 'bg-[#5754E5]',
            )}
            onClick={() => {
              onChangeStep()
              functionTracks('1')
              paiementFactureUser()
            }}
          >
            Suivant
          </button>
        {/* </div> */}
      </div>
      <Modal isOpen={openModalGuide} onClose={() => setOpenModalGuide(false)}>
        <div className={`w-full flex flex-col items-center text-center max-h-[80vh] overflow-y-auto scrollbar-webkit`}>
          <span className="mb-5 text-[20px] font-medium text-[#DADADA]">Guide</span>
          <img className={`  sm:w-auto  rounded-sm`} 
            src={isOperateur === 'Soned' ? SonedInfoIcon : StegInfoIcon} width={465}  
            loading="eager" decoding="async" alt="Steg Info Icon" 
          />
          <span className="mb-5 text-[18px] sm:text-[16px] font-medium text-[#FFFFFF] mt-[40px] ">Où trouver le numéro de {isOperateur === 'Soned' ? 'contrat' : ' facture' }  ?</span>
          <p className="pb-10 w-[350px] sm:w-full  text-[13px] font-medium text-[#C2C2C2]">
            Vous trouverez le numéro de contrat sur votre facture {isOperateur === 'Soned' ? 'SONEDE' : ' STEG' }, comme indiqué ci-dessus. 
            <br/>Assurez-vous de le saisir
            correctement
          </p>
        </div>
      </Modal>
    </div>
  )
}

export default Choix
